import { Amount } from './Amount.js';
import { BinaryButtons } from './BinaryButtons.js';
import { BinaryVertical } from './BinaryVertical.js';
import { Checkbox } from './Checkbox.js';
import { Delay } from './Delay.js';
import { Redirect } from './Redirect.js';
import { AngularRedirect } from './AngularRedirect.js';
import { ButtonRow } from './ButtonsRow.js';
import { FiveButtons } from './FiveButtons.js';
import { FiveValueButtons } from './FiveValueButtons.js';
import { Info } from './Info.js';
import { InfoDualReplace } from './InfoDualReplace.js';
import { InfoManyTexts } from './InfoManyTexts.js';
import { InfoReplace } from './InfoReplace.js';
import { InfoScale } from './InfoScale.js';
import { InfoValue } from './InfoValue.js';
import { Label } from './Label.js';
import { Placeholder } from './Placeholder.js';
import { Progressbar } from './Progressbar.js';
import { NextStep } from './NextStep.js';
import { RealityOutput } from './RealityOutput.js';
import { Scale } from './Scale.js';
import { SevenButtons } from './SevenButtons.js';
import { SimpleOutput } from './SimpleOutput.js';
import { ThreeButtons } from './ThreeButtons.js';
import { WonLostAmount } from './WonLostAmount.js';

import { LogicNot } from './LogicNot.js';
import { LogicPercent } from './LogicPercent.js';
import { LogicParameter } from './LogicParameter.js';
import { Logic3x3matrix } from './Logic3x3matrix.js';
import { LogicGoto } from './LogicGoto.js';

import { LogicThreeIntervals } from './LogicThreeIntervals.js';
import { LogicSum } from './LogicSum.js';
import { LogicScale } from './LogicScale.js';
import { LogicRoughlyEqual } from './LogicRoughlyEqual.js';
import { LogicRealitycheck } from './LogicRealitycheck.js';
import { LogicQuotient } from './LogicQuotient.js';
import { LogicPost } from './LogicPost.js';
import { LogicEvents } from './LogicEvents.js';
import { LogicNextStep } from './LogicNextStep.js';
import { LogicMultiplication } from './LogicMultiplication.js';
import { LogicGreatest } from './LogicGreatest.js';
import { LogicGreaterThanParam } from './LogicGreaterThanParam.js';
import { LogicGreaterThan } from './LogicGreaterThan.js';
import { LogicCssClass } from './LogicCssClass.js';
import { LogicInputNumber } from './LogicInputNumber.js';

class ComponentLibrary {

    #componentList = {};

    constructor() {
        this.#register(Amount);
        this.#register(BinaryButtons);
        this.#register(BinaryVertical);
        this.#register(FiveButtons);
        this.#register(FiveValueButtons);
        this.#register(NextStep);
        this.#register(RealityOutput);
        this.#register(Scale);
        this.#register(SevenButtons);
        this.#register(ThreeButtons);
        this.#register(WonLostAmount);
        this.#register(ButtonRow);
        this.#register(Delay);
        this.#register(Redirect);
        this.#register(AngularRedirect);

        this.#register(Info);
        this.#register(InfoDualReplace);
        this.#register(InfoManyTexts);
        this.#register(InfoReplace);
        this.#register(InfoScale);
        this.#register(InfoValue);

        this.#register(LogicNot);
        this.#register(LogicPercent);
        this.#register(LogicParameter);
        this.#register(Logic3x3matrix);
        this.#register(LogicGoto);
        this.#register(LogicThreeIntervals);
        this.#register(LogicSum);
        this.#register(LogicScale);
        this.#register(LogicRoughlyEqual);
        this.#register(LogicRealitycheck);
        this.#register(LogicQuotient);
        this.#register(LogicNextStep);
        this.#register(LogicMultiplication);
        this.#register(LogicGreatest);
        this.#register(LogicPost);
        this.#register(LogicEvents);
        this.#register(LogicGreaterThan);
        this.#register(LogicGreaterThanParam);
        this.#register(LogicCssClass);
        this.#register(LogicInputNumber);

        this.#register(Checkbox);
        this.#register(Label);
        this.#register(SimpleOutput);
        this.#register(Placeholder);
        this.#register(Progressbar);
    }

    #register(component) {
        for (var i in this.#componentList) {
            let existingComponent = this.#componentList[i];
            if (existingComponent.staticId == component.staticId) {
                throw new Error("ComponentLibrary: Duplicate component id: " + component.staticId);
            }
        }

        this.#componentList[component.staticId] = component;
    }

    all() {
        return this.#componentList;
    }

    getType(id) {
        return this.#componentList[id];
    }

    createNewInstance(type, id) {
        for (var i in this.#componentList) {
            let component = this.#componentList[i];
            if (component.staticId == type) {
                return new component(id);
            }
        }

        console.error("createNewInstance-> Unknown type: " + type);
        return null;
    }
}

export { ComponentLibrary }